import { BaseFloorplanViewElement2D } from './BaseFloorplanViewElement2D.js';
import { EVENT_MOVED, EVENT_UPDATED, EVENT_DELETED } from '../../core/events.js';
import { Dimensioning } from '../../core/dimensioning.js';
import { Point } from 'pixi.js';
import { Vector3, Vector2 } from 'three';
import { Utils } from '../../core/utils';
import swal from 'sweetalert';


export class WallItemView2D extends BaseFloorplanViewElement2D {
    constructor(floorplan, options, wall, wallItem) {
        super(floorplan, options);
        this.item = wallItem;
        this.wall = wall;

        // needed to avoid collision with other objects
        this.lastAcceptablePosition;

        // event that fire when there is a modification
        this.updatedEvent = this.updateDraw.bind(this);
        this.deleteEvent = this.delete.bind(this);
        this.wall.addEventListener(EVENT_UPDATED, this.updatedEvent);
        this.wall.addEventListener(EVENT_MOVED, this.updatedEvent);
        this.item.addEventListener(EVENT_DELETED, this.deleteEvent);

        this.colour;
        if (wallItem.metadata.itemType == 7) {
            this.colour = 0x00FF00;
        } else if (wallItem.metadata.itemType == 3) {
            this.colour = 0x0000FF;
        }
        this.update();
    }

    // functions related to mouse actions
    __click(evt) {
        super.__click(evt);
    }

    __dragStart(evt) {
        super.__dragStart(evt);
        this.lastAcceptablePosition = this.item.__position.clone();
    }

    __dragMove(evt) {
        super.__dragMove(evt);
        // the door should move only if we are dragging
        if (this.__isDragging) {
            // mouse position in canvas coordinates
            let mouseCoordinates = evt.data.getLocalPosition(this.parent);
            let mCanvasCoordinates = Dimensioning.pixelToCmVector2D(mouseCoordinates);
            // I have absolutely no idea why it is needed to multply the coordinates by 4,
            // but it does work, even when zooming or moving around
            mCanvasCoordinates.x = mCanvasCoordinates.x * 4;
            mCanvasCoordinates.y = mCanvasCoordinates.y * 4;

            // find the point on the wall closest to the mouse
            let projectionPoint = Utils.closestPointOnLine(mCanvasCoordinates, this.wall.start._co, this.wall.end._co);

            // update position of the item in the wall
            let newPos = new Vector3(projectionPoint.x, this.item.__currentWallSnapPoint.y, projectionPoint.y);
            this.item.snapToWall(newPos, this.wall, this.item.__currentWallEdge);
            this.item.__followWall();
        }
    }

    __dragEnd(evt) {
        super.__dragEnd(evt);
        //check for collision
        if(Utils.doItemsCollide(this.wall.__inWallItems, this.item.__position2d, this.item.halfSize.x, this.item.__id )){
            swal({
                text: "Two objects can't occupy the same space!"
            });
            // put item back at the last acceptable position
            this.item.snapToWall(this.lastAcceptablePosition, this.wall, this.item.__currentWallEdge);
            this.item.__followWall();
        }
    }

    updateDraw(evt) {
        this.update();
    }

    update() {
        this.clear();
        let pos = new Vector2(this.item.position.x, this.item.position.z);
        let width = this.item.halfSize.x;
        let depth = this.item.halfSize.z;

        let wallDirection = this.wall.wallDirectionNormalized();

        let right = wallDirection.clone().multiplyScalar(width);
        let left = wallDirection.clone().multiplyScalar(width).multiplyScalar(-1);
        let up = wallDirection.clone().rotateAround(new Vector2(), Math.PI * 0.5).multiplyScalar(depth);
        let down = up.clone().multiplyScalar(-1);

        let a = pos.clone().add(right.clone().add(up));
        let b = pos.clone().add(right.clone().sub(up));
        let c = pos.clone().add(left.clone().add(down));
        let d = pos.clone().add(left.clone().sub(down));

        let points = [
            new Point(Dimensioning.cmToPixel(a.x), Dimensioning.cmToPixel(a.y)),
            new Point(Dimensioning.cmToPixel(b.x), Dimensioning.cmToPixel(b.y)),
            new Point(Dimensioning.cmToPixel(c.x), Dimensioning.cmToPixel(c.y)),
            new Point(Dimensioning.cmToPixel(d.x), Dimensioning.cmToPixel(d.y)),
        ];

        //this.beginFill(0x0000F0, 0.85);
        this.beginFill(this.colour, 0.90);
        this.drawPolygon(points);
        this.endFill();
    }

    delete() {
        this.remove();
        //this.wall=null; 
        this.item = null;
    }

    remove() {
        this.wall.removeEventListener(EVENT_MOVED, this.__wallUpdatedEvent);
        this.wall.removeEventListener(EVENT_UPDATED, this.__wallUpdatedEvent);
        this.wall.removeEventListener(EVENT_DELETED, this.__wallDeletedEvent);
        super.remove();
    }
}
